module.exports = __webpack_public_path__ + "static/media/Montserrat-ExtraBoldItalic.52a50ca0.ttf";